export default __webpack_public_path__ + "static/media/closeicon.aeec27d3.png";